<template>
  <div class="pa-3 full-height">
    <div v-show="isLoading" class="l layout full-width full-height align-center justify-center">
      <loading />
    </div>
    <v-fade-transition v-show="computedItems.length > 0 && isLoading === false" group>
      <reference
        :is-selected="selected ? selected.map(x => x._id).includes(reference._id) : false"
        v-for="reference in computedItems"
        :key="reference._id"
        :can-select="selectable"
        :initial-reference="reference"
        @change="onSelect"
      />
    </v-fade-transition>
    <div v-show="computedItems.length === 0 && isLoading === false" class="empty-filter">
      No Reference available for the search criteria
    </div>
    <div v-show="items.length === 0 && isLoading === false" class="empty">
      No References available
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
//
import { confirm } from '@/utils/modal';
//
import { GET_ALL_REFERENCES, REFERENCE_TABLE_HEADER, UPDATE_REFERENCE } from '@/config/constants';
import { TaskStatus } from '@/enums/taskstatus';
import EditReferenceDialog from '@/components/dialogs/EditReferenceDialog';
import Vue from 'vue';
import icons from '../../mixins/icons';
import referenceTileVue from '../references/reference-tile.vue';
import LoadingVue from '@/components/core/animations/loading-animation';

export default {
  components: { EditReferenceDialog, reference: referenceTileVue, loading: LoadingVue },
  mixins: [icons],
  props: {
    selected: {
      type: Array
    },
    assign: {
      type: Boolean,
      default: false
    },
    highlighted: String,
    selectable: {
      type: Boolean,
      default: false
    },
    searchProp: String
  },
  data: function() {
    return {
      pagination: { page: 1, rowsPerPage: -1 },
      header: REFERENCE_TABLE_HEADER(this.assign),
      search: this.highlighted || '',
      editDialog: {},
      selectedReferences: new Map(),
      error: null,
      isLoading: false
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      await this.$store.dispatch(GET_ALL_REFERENCES);
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapState('references', {
      items: state => state.items
    }),
    computedItems() {
      return this.items.filter(i => {
        let f = true;
        if (this.searchProp) {
          const regex = new RegExp(this.searchProp, 'gi');
          f = i.text.match(regex);
        }
        return f;
      });
    },
    tableHeight() {
      return '550px';
    }
  },
  watch: {
    selected: {
      handler: function(w, p) {
        if (w !== p) {
          this.$emit('selection-change', w);
        }
      }
    }
  },
  methods: {
    async editItem(item) {
      let text = prompt('Neuer Text: ');
      if (text) {
        let new_item = _.cloneDeep(item);
        new_item.text = text;
        await this.$store.dispatch(UPDATE_REFERENCE, new_item);
      }
    },
    deleteItem(item) {
      confirm('Delete CFE', `Are you sure?`, 'Yes', 'No').then(async yes => {
        if (yes) {
          await this.$store.dispatch(UPDATE_REFERENCE, {
            ...item,
            active: false
          });
        }
      });
    },
    //
    onSelect(selected) {
      if (this.selectedReferences.has(selected._id)) {
        this.selectedReferences.delete(selected._id);
      } else {
        this.selectedReferences.set(selected._id, selected);
      }

      this.$emit('changed-selection', Array.from(this.selectedReferences.values()));

      // this.selected = selected;
      // this.$emit("selected", selected);
    }
  },
  filters: {
    formatTime(time) {
      return moment(time).format('DD.MM.YY kk:mm');
    }
  }
};
</script>

<style scoped>
.chip {
  padding: 3px;
  max-width: 150px;
  min-width: 100px;
  border-radius: 3px;
  background-color: var(--light-form-bg);
  word-break: break-all;
  word-break-wrap: wrap;
  cursor: pointer;
  text-align: center;
}
.data-table {
  height: calc(100% - 72px);
}

.card {
  position: absolute;
  width: 100%;
  height: 100%;
}

.list-style li {
  list-style: circle !important;
}
.text {
  text-align: justify;
  padding: 10px;
}
</style>
